import { useQuery } from '@tanstack/react-query'

import { useQueryErrorAlert } from '@hooks/useQueryErrorAlert'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchLabels, initialState } from '../services/fetchLabels'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { useLabelsSearch, queryKey }

const queryKey = 'aanvraag-labels'

const useLabelsSearch = ({
  externalFilters: filters,
}: {
  externalFilters: ContractinstellingenSearchFilters
}) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isFetching: isLoading,
    error,
    errorUpdatedAt,
  } = useQuery({
    queryKey: [queryKey, filters],
    queryFn: () => fetchLabels(filters),
    enabled: hasPermissions && !!filters.combi,
  })

  useQueryErrorAlert(error, errorUpdatedAt, 'Fout bij ophalen van labels')

  return {
    data: data || initialState.data,
    isLoading,
    error,
  }
}
